// src/components/finish-your-booking/finish-your-booking.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    referrerId\n    linkName\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment FinishYourBookingCardFragment on HomeCard {\n    __typename\n    heading\n    secondaries {\n      __typename\n      text\n    }\n    image {\n      __typename\n      description\n      url\n      aspectRatio\n      description\n      thumbnailClickAnalytics {\n        __typename\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    links {\n      __typename\n      action {\n        __typename\n        ... on UILinkAction {\n          __typename\n          analytics {\n            __typename\n            ...ClientSideAnalyticsFragment\n          }\n          target\n          resource {\n            __typename\n            value\n          }\n          useRelativePath\n        }\n      }\n      disabled\n      size\n      text\n    }\n    buttons {\n      __typename\n      ... on UISecondaryButton {\n        __typename\n        disabled\n        icon {\n          description\n          id\n          token\n        }\n        primary\n        accessibility\n        analytics {\n          __typename\n          ...ClientSideAnalyticsFragment\n        }\n        action {\n          __typename\n          ... on UILinkAction {\n            __typename\n            analytics {\n              __typename\n              ...ClientSideAnalyticsFragment\n            }\n            target\n            resource {\n              __typename\n              value\n            }\n            useRelativePath\n          }\n        }\n      }\n    }\n    dismissAction {\n      __typename\n      dismissAction {\n        __typename\n        label\n        analytics {\n          __typename\n          ...ClientSideAnalyticsFragment\n        }\n        accessibility\n      }\n      dismissIcon {\n        description\n        id\n        token\n      }\n    }\n    impressionTracking {\n      __typename\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query FinishYourBookingQuery($context: ContextInput!) {\n    abandonedCheckout(context: $context) {\n      __typename\n      heading {\n        text\n      }\n      card {\n        ...FinishYourBookingCardFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation RemoveAbandonedCheckoutMutation($context: ContextInput!) {\n    discardAbandonedCheckout(context: $context) {\n      __typename\n      isSuccessful\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React2, { useState } from "react";
import { gql as gql3, useMutation, useQuery } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
    FINISHYOURBOOKING_MUTATION_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "FINISHYOURBOOKING_MUTATION_FAILURE"),
    FINISHYOURBOOKING_UNWRAP_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "FINISHYOURBOOKING_UNWRAP_FAILURE")
};
// src/components/finish-your-booking/__private/__fragments/finish-your-booking-card.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSButtonSize, EGDSExternalButton, EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/utils/client-side-analytics.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// src/components/finish-your-booking/__private/__fragments/finish-your-booking-card.tsx
var fragment = gql2(_templateObject1(), ClientSideAnalyticsFragment);
var FinishYourBookingCard = function(props) {
    var _buttons__action, _buttons__action1, _buttons__action2, _buttons__action3, _dismissAction_dismissIcon, _dismissAction_dismissIcon1, _dismissAction_dismissIcon2;
    var data = props.data, isDesktop = props.isDesktop, onDismiss = props.onDismiss;
    var heading = data.heading, secondaries = data.secondaries, image = data.image, links = data.links, buttons = data.buttons, dismissAction = data.dismissAction, impressionTracking = data.impressionTracking;
    var clickTracker = useClickTracker();
    var onLinkClickCapture = function() {
        if (links) {
            clickTracker(links[0].action.analytics.referrerId, links[0].action.analytics.linkName);
        }
    };
    var onButtonClickCapture = function() {
        var _buttons__action;
        if (buttons && buttons[0].__typename === "UISecondaryButton" && ((_buttons__action = buttons[0].action) === null || _buttons__action === void 0 ? void 0 : _buttons__action.__typename) === "UILinkAction") {
            clickTracker(buttons[0].action.analytics.referrerId, buttons[0].action.analytics.linkName);
        }
    };
    var onDismissClickCapture = function() {
        if (dismissAction) {
            clickTracker(dismissAction.dismissAction.analytics.referrerId, dismissAction.dismissAction.analytics.linkName);
        }
        onDismiss();
    };
    var mobileLayout = /* @__PURE__ */ React.createElement(React.Fragment, null, buttons && buttons[0].__typename === "UISecondaryButton" && ((_buttons__action = buttons[0].action) === null || _buttons__action === void 0 ? void 0 : _buttons__action.__typename) === "UILinkAction" && /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSSecondaryButton, {
        href: (_buttons__action1 = buttons[0].action) === null || _buttons__action1 === void 0 ? void 0 : _buttons__action1.resource.value,
        onClick: onButtonClickCapture,
        size: EGDSButtonSize.SMALL
    }, buttons[0].primary))), links && /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSLink, {
        onClick: onLinkClickCapture,
        size: "small"
    }, /* @__PURE__ */ React.createElement("a", {
        href: links[0].action.resource.value
    }, links[0].text)))));
    var desktopLayout = /* @__PURE__ */ React.createElement(React.Fragment, null, links && /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSLink, {
        onClick: onLinkClickCapture,
        size: "medium"
    }, /* @__PURE__ */ React.createElement("a", {
        href: links[0].action.resource.value
    }, links[0].text)))), buttons && buttons[0].__typename === "UISecondaryButton" && ((_buttons__action2 = buttons[0].action) === null || _buttons__action2 === void 0 ? void 0 : _buttons__action2.__typename) === "UILinkAction" && /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSSecondaryButton, {
        href: (_buttons__action3 = buttons[0].action) === null || _buttons__action3 === void 0 ? void 0 : _buttons__action3.resource.value,
        onClick: onButtonClickCapture,
        size: EGDSButtonSize.MEDIUM
    }, buttons[0].primary))));
    var _dismissAction_dismissIcon_token;
    return /* @__PURE__ */ React.createElement(IntersectionTracker, {
        referrerId: impressionTracking ? impressionTracking.referrerId : "",
        linkName: impressionTracking ? impressionTracking.linkName : ""
    }, /* @__PURE__ */ React.createElement(EGDSCard, {
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React.createElement(EGDSLayoutGrid, {
        columns: isDesktop ? 10 : 3,
        autoRows: [
            MinMax("auto", "70x")
        ]
    }, /* @__PURE__ */ React.createElement(EGDSLayoutGridItem, {
        colSpan: isDesktop ? 6 : 1
    }, /* @__PURE__ */ React.createElement(EGDSFigure, {
        ratio: EGDSFigureAspectRatioType.R21_9
    }, /* @__PURE__ */ React.createElement(EGDSImage, {
        alt: image === null || image === void 0 ? void 0 : image.description,
        src: image === null || image === void 0 ? void 0 : image.url,
        placeholderImage: true
    }))), /* @__PURE__ */ React.createElement(EGDSLayoutGridItem, {
        colSpan: isDesktop ? 4 : 2
    }, /* @__PURE__ */ React.createElement(EGDSCardContentSection, {
        padded: [
            "blockend",
            "blockstart"
        ]
    }, /* @__PURE__ */ React.createElement(EGDSLayoutGrid, {
        blockSize: "100%",
        columns: [
            "auto",
            "min-content"
        ]
    }, /* @__PURE__ */ React.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */ React.createElement(EGDSLayoutFlex, {
        justifyContent: "center",
        direction: "column"
    }, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            inlinestart: isDesktop ? "six" : "three"
        }
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(EGDSHeading, {
        tag: "h4",
        size: 6
    }, heading), /* @__PURE__ */ React.createElement(EGDSSpacing, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlex, {
        direction: "column",
        space: "one"
    }, secondaries === null || secondaries === void 0 ? void 0 : secondaries.map(function(secondary, index) {
        return /* @__PURE__ */ React.createElement(EGDSText, {
            key: index,
            size: 300
        }, secondary.text);
    }))), isDesktop ? desktopLayout : mobileLayout)))), /* @__PURE__ */ React.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */ React.createElement(EGDSLayoutPosition, {
        type: "relative",
        position: {
            top: isDesktop ? "minus-one" : "minus-three",
            right: isDesktop ? "two" : "zero"
        }
    }, /* @__PURE__ */ React.createElement(EGDSExternalButton, {
        size: EGDSButtonSize.LARGE,
        onClick: onDismissClickCapture
    }, /* @__PURE__ */ React.createElement(EGDSIcon, {
        name: (_dismissAction_dismissIcon_token = dismissAction === null || dismissAction === void 0 ? void 0 : (_dismissAction_dismissIcon = dismissAction.dismissIcon) === null || _dismissAction_dismissIcon === void 0 ? void 0 : _dismissAction_dismissIcon.token) !== null && _dismissAction_dismissIcon_token !== void 0 ? _dismissAction_dismissIcon_token : "",
        title: dismissAction === null || dismissAction === void 0 ? void 0 : (_dismissAction_dismissIcon1 = dismissAction.dismissIcon) === null || _dismissAction_dismissIcon1 === void 0 ? void 0 : _dismissAction_dismissIcon1.id,
        id: dismissAction === null || dismissAction === void 0 ? void 0 : (_dismissAction_dismissIcon2 = dismissAction.dismissIcon) === null || _dismissAction_dismissIcon2 === void 0 ? void 0 : _dismissAction_dismissIcon2.id,
        size: EGDSIconSize.LARGE
    }))))))))));
};
FinishYourBookingCard.fragment = fragment;
FinishYourBookingCard.displayName = "FinishYourBookingCard";
// src/components/finish-your-booking/finish-your-booking.tsx
var __Query = gql3(_templateObject2(), FinishYourBookingCard.fragment);
var __Mutation = gql3(_templateObject3());
var FinishYourBooking = function(props) {
    var skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var logEvents = useLoggerEvents(EVENTS);
    var _useMutation = _sliced_to_array(useMutation(__Mutation), 1), removeAbandonedCheckout = _useMutation[0];
    var _useState = _sliced_to_array(useState(false), 2), isDismissed = _useState[0], setIsDismissed = _useState[1];
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.abandonedCheckout || isDismissed) {
        return null;
    }
    var finishYourBookingHeading = data.abandonedCheckout.heading.text;
    var handleDismiss = function() {
        var _ref = _async_to_generator(function() {
            var _response_data_discardAbandonedCheckout, _response_data, response, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            removeAbandonedCheckout({
                                variables: {
                                    context: context
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if ((_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_discardAbandonedCheckout = _response_data.discardAbandonedCheckout) === null || _response_data_discardAbandonedCheckout === void 0 ? void 0 : _response_data_discardAbandonedCheckout.isSuccessful) {
                            setIsDismissed(true);
                        } else {
                            logEvents.FINISHYOURBOOKING_UNWRAP_FAILURE.log({
                                message: "Unwrapping discardAbandonedCheckout failed",
                                response: response
                            });
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        logEvents.FINISHYOURBOOKING_MUTATION_FAILURE.log({
                            messasge: "Failed to dismiss Finish Your Booking card",
                            err: err
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDismiss() {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React2.createElement(Viewport, null, /* @__PURE__ */ React2.createElement(ViewSmall, null, /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(EGDSHeading2, {
        tag: "h3",
        size: 5
    }, finishYourBookingHeading), /* @__PURE__ */ React2.createElement(EGDSSpacing2, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(FinishYourBookingCard, {
        data: data.abandonedCheckout.card,
        onDismiss: handleDismiss
    }))))), /* @__PURE__ */ React2.createElement(ViewMedium, null, /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(EGDSHeading2, {
        tag: "h2",
        size: 4
    }, finishYourBookingHeading), /* @__PURE__ */ React2.createElement(EGDSSpacing2, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(FinishYourBookingCard, {
        data: data.abandonedCheckout.card,
        isDesktop: true,
        onDismiss: handleDismiss
    }))))));
};
FinishYourBooking.displayName = "sharedui-FinishYourBooking";
export { FinishYourBooking };
//# sourceMappingURL=index.js.map